import React from "react";
import classNames from "classnames";

interface SliderSwitchProps {
  isOn: boolean;
}

const SliderSwitch: React.FC<SliderSwitchProps> = ({ isOn }) => {
  const containerClasses = classNames(
    "w-[30px]",
    "h-[18px]",
    "rounded-[9px]",
    "relative",
    "cursor-pointer",
    "inline-flex",
    "items-center",
    "flex-shrink-0",
    "transition-colors duration-200 ease-in-out",
    {
      "bg-purple-600": isOn,
      "bg-gray-500": !isOn,
    },
  );

  const toggleClasses = classNames(
    "w-[14px]",
    "h-[14px]",
    "rounded-full",
    "bg-white",
    "absolute",
    "left-[2px]",
    "transition-transform duration-200 ease-in-out",
    {
      "translate-x-[12px]": isOn,
      "translate-x-0": !isOn,
    },
  );

  return (
    <div className={containerClasses}>
      <div className={toggleClasses} />
    </div>
  );
};

export default SliderSwitch;
